import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import BusClaimApiService from "../../../adapters/xhr/BusClaimApiService";
import { MyCheckbox } from "../../../components/my-checkbox/MyCheckbox";
import { getConfirmation } from "../../../components/my-confirmation-dialog/MyConfirmationDialog";
import MyContext from "../../../contexts/MyContext";
import { BusTheme } from "../../../infrastructure/BusThemeProvider";
import { formatDepartureDate, toBase64 } from "../../../Utils";
import { FormWrapper } from "../FormWrapper";

export const TicketForm5 = (props) => {
  const { t } = useTranslation();
  const myContext = useContext(MyContext);
  const [declareInformationErr, setDeclareInformationErr] = useState(null);
  const [confirmDuplicate, setConfirmDuplicate] = useState(null);

  const validate = async () => {
    let isValid = true;
    if (!myContext.declareInformation) {
      setDeclareInformationErr("ensure_info");
      isValid = false;
    } else {
      setDeclareInformationErr(null);
    }
    if (isValid) {
      let claimReceipts = [];
      if (!myContext.distance?.isShortTrain && (myContext.foodTotalCost || (myContext.foodReceipt && myContext.foodReceipt.length > 0))) {
        let foodReceipt = {
          id: "00000000-0000-0000-0000-000000000000",
          claimId: "00000000-0000-0000-0000-000000000000",
          receiptType: {
            id: "00000000-0000-0000-0000-000000000000",
            name: "Food",
          },
          transportationType: 0,
          totalCost: Number(myContext.foodTotalCost),
          fromAddress: "string",
          toAddress: "string",
          distance: 120,
          busReceiptAttachments: await Promise.all(
            myContext.foodReceipt.map(async (receipt) => {
              return {
                id: "00000000-0000-0000-0000-000000000000",
                receiptId: "00000000-0000-0000-0000-000000000000",
                file: await toBase64(receipt),
                fileName: receipt.name,
              };
            }),
          ),
        };
        claimReceipts.push(foodReceipt);
      }
      if (myContext.numberOfKmDriven || myContext.transportTotalCost || (myContext.transportReceipt && myContext.transportReceipt.length > 0)) {
        let transportReceipt = {
          id: "00000000-0000-0000-0000-000000000000",
          claimId: "00000000-0000-0000-0000-000000000000",
          receiptType: {
            id: "00000000-0000-0000-0000-000000000000",
            name: "Transportation",
          },
          transportationType: myContext.transportationType,
          totalCost: Number(myContext.transportTotalCost),
          fromAddress: myContext.fromAddress,
          toAddress: myContext.toAddress,
          registrationNumber: myContext.registrationNumber,
          distance: myContext.numberOfKmDriven != null ? Number(myContext.numberOfKmDriven) : 0,
          busReceiptAttachments: await Promise.all(
            myContext.transportReceipt.map(async (receipt) => {
              return {
                id: "00000000-0000-0000-0000-000000000000",
                receiptId: "00000000-0000-0000-0000-000000000000",
                file: await toBase64(receipt),
                fileName: receipt.name,
              };
            }),
          ),
        };
        claimReceipts.push(transportReceipt);
      }
      if (!myContext.distance?.isShortTrain && (myContext.accommodationTotalCost || (myContext.accommodationReceipt && myContext.accommodationReceipt.length > 0))) {
        let accommodationReceipt = {
          id: "00000000-0000-0000-0000-000000000000",
          claimId: "00000000-0000-0000-0000-000000000000",
          receiptType: {
            id: "00000000-0000-0000-0000-000000000000",
            name: "Extra",
          },
          transportationType: 0,
          totalCost: Number(myContext.accommodationTotalCost),
          fromAddress: "string",
          toAddress: "string",
          distance: 120,
          busReceiptAttachments: await Promise.all(
            myContext.accommodationReceipt.map(async (receipt) => {
              return {
                id: "00000000-0000-0000-0000-000000000000",
                receiptId: "00000000-0000-0000-0000-000000000000",
                file: await toBase64(receipt),
                fileName: receipt.name,
              };
            }),
          ),
        };
        claimReceipts.push(accommodationReceipt);
      }
      let result = await BusClaimApiService.create({
        id: "00000000-0000-0000-0000-000000000000",
        confirmDuplicate: confirmDuplicate,
        payoutOption: myContext.payoutOption,
        customer: {
          id: "00000000-0000-0000-0000-000000000000",
          firstName: myContext.firstname,
          surName: myContext.surname,
          city: myContext.city?.trim(),
          postalCode: myContext.postalCode?.trim(),
          streetNameAndNumber: myContext.streetNameAndNumber?.trim(),
          identityNumber: myContext.personalID?.trim(),
          bankAccountNumber: myContext.bankAccount,
          mobileNumber: myContext.countryCode.phone + myContext.mobileNumber?.replace(/\s/g, "").replace(/^\D+/g, "").replace(/^0/, ""),
          email: myContext.email?.trim(),
          clearingNumber: myContext.clearingNumber,
          hasIdentityNumber: myContext.hasPersonalID,
          IBAN: myContext.IBAN?.trim(),
          BIC: myContext.BIC?.trim(),
        },
        ticketNumber: myContext.biljettnummerValue?.toUpperCase().trim(),
        ticketType: myContext.ticketType,
        departureStationId: myContext.departureStation?.key,
        arrivalStationId: myContext.arrivalStation?.key,
        departureDate: `${formatDepartureDate(myContext.departureDate, myContext.departureTime).toISOString()}`,
        comment: myContext.otherComments,
        status: 0,
        transportationNumber: myContext.line?.shortName ? Number(myContext.line?.shortName) : 0,
        refundType: {
          id: "00000000-0000-0000-0000-000000000000",
          name: myContext.refundType,
        },
        busClaimReceipts: claimReceipts,
      });
      if (!result.isSuccess) {
        let message = t("refresh_page_message");
        if (result.errorMessage == "max_number_of_claims_reached") {
          message = t("max_number_of_claims_reached");
        }
        const confirmed = await getConfirmation({
          title: t("error"),
          message: message,
          theme: BusTheme,
        });
        if (confirmed) window.location.reload();
      } else {
        myContext.changeActiveSlide((myContext.activeSlide += 1));
      }
    }
  };

  return (
    <MyContext.Consumer>
      {(context) => (
        <React.Fragment>
          <FormWrapper continueButtonLabel={t("send_in_application")} onContinue={validate} onBack={props.slickPrev} number={`5/5`} heading={`${t("submit_app")}`}>
            <MyCheckbox label={t("declare_information")} helperText={t(declareInformationErr)} checked={context.declareInformation} onChange={context.changeDeclareInformation} className="margin top-1" />
          </FormWrapper>
        </React.Fragment>
      )}
    </MyContext.Consumer>
  );
};
